import React from "react";
import ReportDetail from "../ReportDetail";
import ProductsReport from "./ProductsReport";

const Products = () => {
  return (
    <ReportDetail title="products_report">
      <ProductsReport />
    </ReportDetail>
  );
};

export default Products;
